import { useField } from "formik";
import React, { useMemo } from "react";

import { FieldContainer, FieldContainerProps } from "./FieldContainer";
import { DoctorSelectWrapper, DoctorSelectWrapperProps } from "../doctor/DoctorSelectWrapper";

interface Props extends DoctorSelectWrapperProps {
  readonly name: string;
  readonly label?: string;
  readonly fieldProps?: Omit<FieldContainerProps, "label" | "children">;
}

export function DoctorSelectField({
  name,
  label,
  fieldProps,
  onlyDoctors,
  clinicId,
  ...props
}: Props) {
  const [field, meta, helpers] = useField(name);

  const error = useMemo(() => {
    if (meta.touched && meta.error) {
      return meta.error;
    }
  }, [meta.error, meta.touched]);

  return (
    <FieldContainer
      {...fieldProps}
      label={label}
      error={!!error}
      hintText={error || fieldProps?.hintText}
    >
      <DoctorSelectWrapper
        {...props}
        {...field}
        onlyDoctors={onlyDoctors}
        onChange={(x, e) => {
          helpers.setValue(x);

          if (props.onChange) {
            props.onChange(x, e);
          }
        }}
      />
    </FieldContainer>
  );
}
